import React from 'react'

import { Button } from 'ui/components/Button'
import {
    Modal,
    ModalContent,
    ModalContentInner,
    ModalFooter,
    ModalFooterButtonGroup,
    ModalHeader,
} from 'ui/components/Modal'

import { useExportAppTemplateModalState } from './hooks/useExportAppTemplateModalState'
import { AppTemplateDetail } from './AppTemplateDetail'

import { TemplateModalContentInnerStyle, TemplateModalContentStyle } from './TemplateModal.css'

type ExportAppTemplateModalProps = {
    open: boolean
    onClose: () => void
    stack: StackDto | null
}

export const ExportAppTemplateModal: React.FC<ExportAppTemplateModalProps> = ({
    open,
    onClose,
    stack,
}) => {
    const {
        onOpenChange,
        appTemplate,
        onChangeAppTemplate,
        isLoading,
        onInteractOutside,
        onExport,
    } = useExportAppTemplateModalState({
        stack,
        onClose,
    })

    return (
        <Modal open={open} onOpenChange={onOpenChange} modal={false}>
            <ModalContent
                modal={false}
                zIndex={1300}
                className={TemplateModalContentStyle}
                onInteractOutside={onInteractOutside}
            >
                <ModalHeader title="Export as template" />
                <ModalContentInner className={TemplateModalContentInnerStyle}>
                    <AppTemplateDetail
                        template={appTemplate}
                        isEditable={true}
                        onChange={onChangeAppTemplate}
                        isLoading={isLoading}
                    />
                </ModalContentInner>
                <ModalFooter borderColor="border" borderTopWidth={1}>
                    <ModalFooterButtonGroup layout="inline">
                        <Button size="l" disabled={isLoading} onClick={onExport}>
                            Export
                        </Button>
                    </ModalFooterButtonGroup>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
